import { tap } from 'lodash/fp';
import * as designBuilderApi from '../api/designBuilder';
import AnalyticsConstants from '../analytics/constants';
import {
  createAndSendButtonSubmissionAnalyticsEventForMultipleSkus,
} from '../analytics/commonAnalytics';
import estimateLoaded from './estimateLoaded';
import containerCopied from './containerCopied';
import loaded from './loaded';
import loading from './loading';
import globalError from './globalError';
import uniqueNewName from '../helpers/uniqueNewName';
import smoothScroll from '../helpers/smoothScroll';
import getContainerLabel from '../helpers/getContainerLabel';

const copyContainer = containerId => (dispatch, getState) => {
  dispatch(loading());
  const { uiState, entities } = getState().estimateBuilder;
  const { selectedEstimate } = uiState;
  const { containers, items, estimates } = entities;
  const { allIds, byId } = containers;

  const originalContainers = estimates.byId[selectedEstimate].containers;

  const containersForEstimate = estimates.byId[selectedEstimate].containers;
  const existingNames = allIds.filter(id => containersForEstimate.indexOf(id) > -1)
    .map(givenId => byId[givenId].name);
  const newName = uniqueNewName('Room {{num}}', existingNames);
  const newLabel = getContainerLabel(containersForEstimate.length);

  return designBuilderApi
    .copyContainer(selectedEstimate, containerId, newName, newLabel)
    .then((response) => {
      dispatch(estimateLoaded(response.data));

      const { design } = response.data;
      const newContainerId = design.containers
        .filter(givenId => originalContainers.indexOf(givenId) === -1);
      createAndSendButtonSubmissionAnalyticsEventForMultipleSkus(
        items,
        containerId,
        window.globalConfig.siteId,
        AnalyticsConstants.EventNames.DesignAddProduct,
      );

      dispatch(containerCopied(selectedEstimate, containerId, newContainerId[0]));
      smoothScroll(`#scrolltop-${newContainerId[0]}`);

      return Promise.resolve();
    })
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
};

export default copyContainer;
